<div class="field-wrapper">
  @if (
    field.parent?.type !== "array" &&
    field.type !== "array" &&
    field.parent.type !== "multischema" &&
    to["hideLabel"] !== true
  ) {
    <app-helpful-label
      [for]="id"
      [required]="to.required"
      [label]="to.label || key?.toString()"
      [popoverTitle]="to.label || key?.toString()"
      [tooltip]="key + ''"
      [enabled]="!field.props.disabled"
      [popoverBody]="to.description ? descriptionTmp : undefined"
    >
    </app-helpful-label>
  }
  <ng-template #descriptionTmp>
    {{ to.description }}
  </ng-template>
  <ng-template #fieldComponent></ng-template>
</div>
